import styled, { css } from 'styled-components';
import { Form } from 'formik';
import { StyledFormProps } from './types';

export const Forms = styled(Form)<StyledFormProps>`
  height: ${({ $height }) => $height || '-webkit-fill-available'};
  display: flex;
  flex-direction: column;

  ${({ $show }) =>
    !$show &&
    css`
      display: none;
    `}
`;
